export interface AppVersion {
  Version: string;
  BuildDate: Date;
  FileDate: Date;
  Environment: string;
}

export interface DatabaseLastModifiedSchemaView {
  Id: number;
  LastCreated: Date;
  LastModified: Date;
  LastItemCreated: string;
  LastItemModified: string;
  TrackingState: number;
  ModifiedProperties?: any;
}

export interface DatabaseVersion {
  DatabaseLastModifiedSchemaView: DatabaseLastModifiedSchemaView;
  DatabaseSource: string;
  Catalog: string;
}

export interface RootObject {
  AppVersion: AppVersion;
  DatabaseVersion: DatabaseVersion;
}

export class VersionTable {
  public static table: VersionTable[] = [];
  public static add(item: VersionTable) {
    VersionTable.table.push(item);
  }
  public static addOne(name: string, value: string) {
    VersionTable.add(new VersionTable(name, value));
  }

  constructor(public name: string, public value: string) { }
}